import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type sampleState = {
  count: number
}
const initialState: sampleState = {
  count: 0,
}
export const sampleSlice = createSlice({
  name: 'sample',
  initialState: initialState,
  reducers: {
    format: (state) => {
      state.count = initialState.count
    },
    additional: (state, action: PayloadAction<number>) => {
      state.count += action.payload
    },
    subtraction: (state, action: PayloadAction<number>) => {
      state.count -= action.payload
    },
  },
})

// actionCreatorのこと
export const { format, additional, subtraction } = sampleSlice.actions
export default sampleSlice.reducer
